import React, { useCallback } from 'react';
import NavigationRoute from '../components/DataRoomNavigation/models/NavigationRoute';
import { NavLink } from 'react-router-dom';
import LockclosedIcon from 'icons/Lockclosed.icon';
import Counter from 'components/Counter';
import { useTranslation } from 'react-i18next';
import OnboardingPopup from 'components/OnboardingPopup';
import InformationcircleIcon from 'icons/Informationcircle.icon';
import { SIZE } from 'models/Size';

export default function useNavigationLinks() {
  const { t } = useTranslation();

  return useCallback(
    (
      routes: Array<NavigationRoute>,
      isCollapsed: boolean,
      onClick?: () => void,
    ) =>
      !routes.length ? null : (
        <ul>
          {routes.map(
            ({
              path,
              disabled,
              popupContent,
              icon,
              gif,
              textKey,
              count,
              id,
            }) => {
              const navLink = (
                <NavLink
                  to={path}
                  id={id}
                  onClick={onClick}
                  aria-disabled={disabled}
                  className={({ isActive }) => {
                    if (isActive) return 'active';
                    if (disabled) return 'disabled';
                  }}
                >
                  {icon}
                  {!isCollapsed && t(textKey)}
                  {!isCollapsed && <Counter count={count} size={SIZE.SMALL} />}
                </NavLink>
              );

              return (
                <li key={path}>
                  {navLink}
                  {popupContent && (
                    <OnboardingPopup
                      onHover
                      hasCloseButton={false}
                      gif={gif}
                      anchor={<InformationcircleIcon />}
                      popupContent={t(popupContent)}
                    />
                  )}
                  {disabled && !isCollapsed && <LockclosedIcon />}
                </li>
              );
            },
          )}
        </ul>
      ),
    [t],
  );
}
